

const Songs = ({songsList, playSong}) => {
  
  return (
    <section className='flex flex-wrap items-center justify-center mt-10 md:mt-0 gap-12 md:gap-5'>
      {
        songsList.map((songs,index)=>{
          return <div onClick={()=> playSong(index)} key={songs.id} className='font-[blanka] cursor-pointer'>
          <div className='w-28'><img className='w-full' src={songs.img} alt="" /></div>
          <div className='text-center'>
            <h1>{songs.name}</h1>
          </div>
        </div>
        })
      }
    </section>
  )
}

export default Songs